
import XHeader from 'vux/src/components/x-header/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Divider from 'vux/src/components/divider/index.vue'


const swiperList = [{

img: 'https://ww1.sinaimg.cn/large/663d3650gy1fq66vvsr72j20p00gogo2.jpg',

}, {

img: 'https://ww1.sinaimg.cn/large/663d3650gy1fq66vw1k2wj20p00goq7n.jpg',

}, {
img: 'https://static.vux.li/demo/5.jpg', // 404
fallbackImg: 'https://ww1.sinaimg.cn/large/663d3650gy1fq66vw50iwj20ff0aaaci.jpg'
}]


export default {
components: {
XHeader,
Swiper,
Divider
},
data () {
return {
swiperList:swiperList,
swiperIndex: 0,
image:[],
model:{
goodsId : this.$route.query.goodsId
},
list:"",
}
},
created(){
this.$http.post(this.global.httpUrl + '/rest/v1/m/mall/hardware/getDetail',this.model,{emulateJSON:true}).then(function(res){

if(res.body.success)
{
this.list=res.body.rows;
for(var i=0;i<res.body.goodsImageList.length;i++){
this.image.push({"img":res.body.goodsImageList[i].goodsImage});

};
}
},function(res){
});
this.$http.post(this.global.httpUrl + '/rest/v1/m/user/goods/addFoot',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{

}
},function(res){
});

},
methods: {
swiperChange (index) {
this.swiperIndex = index
}
}
}



// WEBPACK FOOTER //
// ./src/views/hw/hwDetail.vue